import React from 'react';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const DropdownTableHeader = ({ title, style, loadingDropdownOptions, selectedValue, options, handleDropdownChange }) => {
    return (
        <th tabIndex="0" style={{ ...style, maxWidth: "80px" }} className="header-with-dropdown">
            <div>
                <span>{title}</span>
            </div>
            <div style={{ position: 'relative', minHeight: '31px' }}>
                {loadingDropdownOptions ? (
                    <LoadingSpinner size="small" message={null} inline />
                ) : (
                    <select className="dropdown" value={selectedValue} onChange={(e) => handleDropdownChange(e)}>
                        <option key="All" value="All">All</option>
                        {options.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                )}
            </div>
        </th>
    );
};

export default DropdownTableHeader;
